import { Settings, LogOut } from 'lucide-react';
import { Link } from '@tanstack/react-router';
import { Dropdown, DropdownItem, DropdownHeader, Avatar } from '@/components/ui';
import { useAuthStore } from '@/stores/auth';

export function UserDropdown() {
  const { user, logout } = useAuthStore();

  if (!user) return null;

  const handleLogout = () => {
    logout();
  };

  return (
    <Dropdown
      trigger={
        <button className="flex items-center gap-2 p-1 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors">
          <Avatar src={user.avatarUrl} name={`${user.firstName} ${user.lastName}`} size="sm" />
        </button>
      }
      align="right"
      width="w-56"
    >
      <DropdownHeader>
        <div>
          <p className="font-medium text-gray-900 dark:text-gray-100">
            {user.firstName} {user.lastName}
          </p>
          <p className="text-sm text-gray-500 dark:text-gray-400 truncate">{user.email}</p>
        </div>
      </DropdownHeader>

      <div className="py-1">
        <Link to="/settings">
          <DropdownItem>
            <div className="flex items-center gap-3">
              <Settings className="h-4 w-4 text-gray-400" />
              <span>Settings</span>
            </div>
          </DropdownItem>
        </Link>
      </div>

      <div className="border-t border-gray-200 dark:border-gray-700 py-1">
        <DropdownItem onClick={handleLogout} className="text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-950">
          <div className="flex items-center gap-3">
            <LogOut className="h-4 w-4" />
            <span>Sign out</span>
          </div>
        </DropdownItem>
      </div>
    </Dropdown>
  );
}
